import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import LeftNav from './LeftNav';
import MetaTags from 'react-meta-tags';
import Loading from '../../ui/Loading';
import MetaLoader from '../../ui/MetaLoader';
import { Row, Col } from 'react-bootstrap';
import queryString from 'query-string';
import { bindActionCreators } from 'redux';
import fetchDux from '../../../state/fetch-dux';
import { actionCreators } from '../../../state/modals-dux';
import VerifyAddressModal from './VerifyAddressModal';
import ClubPaymentModal from './ClubPaymentModal';
import ClubCancellationModal from './ClubCancellationModal';
import { handleCookieNav } from '../../ui/CookieLink';
import NonActiveMemberMessage from './NonActiveMemberMessage';
import ActiveMemberMessage from './ActiveMemberMessage';
const REACT_APP_CHECKOUT_LINK = `${process.env.REACT_APP_CHECKOUT_LINK}`;

const getClubHtml = ({ ClubTypeId, IsActive }, clubs) => {
  if (!IsActive || !ClubTypeId) return '';
  switch (ClubTypeId) {
    case 1:
      return clubs.ID1;
    case 2:
      return clubs.ID2;
    case 3:
      return clubs.ID3;
    case 4:
      return clubs.ID4;
    default:
      return '';
  }
};

const getBillingAddressDetails = (AddressBook, CreditCards) => {
  const {
    AddressBookId: billingAddressBookID,
    LastFour,
    CardId
  } = (CreditCards || []).find(({ IsDefault }) => IsDefault === true) || {};

  const clubBillingAddress = (AddressBook || [])
    .find(({ AddressBookID }) => AddressBookID === billingAddressBookID) || {};

  return { clubBillingAddress, LastFour, CardId };
};

class ClubInformation extends Component {
  constructor(props) {
    super(props);
    this.state = { loadedClubInfo: false }
    const { getClubDisableTypes } = this.props;
    getClubDisableTypes();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.classList.add(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-template-my-account-club-information',
      'page-template-page-templatesshop-template-my-account-club-information-php',
      'page',
      'page-id-255',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }

  static getDerivedStateFromProps(nextProps, currentState) {
    const { user } = nextProps;
    const { loadedClubInfo } = currentState;
    if (user && !loadedClubInfo) {
      const {
        location: { search },
        getClubById,
        getLookups,
        getUserWaitListStatus
      } = nextProps;
      const searchQuery = queryString.parse(search);
      const { waitlist } = searchQuery;
      if (waitlist) {
        getClubById({ clubTypeId: waitlist, include: 'waitlist,current' });
        getLookups();
      } else {
        getUserWaitListStatus(null, null, null, result => {
          const { waitlist, clubTypeId } = result;
          if (waitlist) {
            getClubById({ clubTypeId, include: 'waitlist,current' });
            getLookups();
          }
        });
      }
      return { loadedClubInfo: true };
    }
    return null;
  }

  componentWillUnmount() {
    document.body.classList.remove(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-template-my-account-club-information',
      'page-template-page-templatesshop-template-my-account-club-information-php',
      'page',
      'page-id-255',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  render() {
    const {
      user,
      clubs,
      inProgress,
      error,
      location: { search },
      clubResult,
      clubByIdInProgress,
      clubError,
      showModal,
      closeModal,
      lookups,
      joinWaitListResult,
      waitListStatusInProgress,
      userWaitListStatusResult,
      acceptInvitationResult,
      acceptInvitation,
      cartResult,
      switchClubMembership,
      switchError,
      switchInProgress,
      validateLoginInProgress,
      deleteInProgress,
      deleteError,
      clubDisableTypes,
      deleteWaitlist,
      clearGetClubById
    } = this.props;

    const searchQuery = queryString.parse(search);
    const { waitlist = (userWaitListStatusResult || {}).clubTypeId } = searchQuery;

    const { ClubMember, AddressBook, CreditCards } = user || {};
    const { waitList } = clubResult || {};
    const { WaitlistId } = waitList || {};

    const {
      IsActive,
      MemberSince,
      ShippingAddressId,
      ClubName: memberClubName,
      IsWillCallOnly,
      WillCallLocation
    } = ClubMember || {};

    const scrollToTop = () => window.scrollTo(0, 0);

    const clubHtml = getClubHtml(ClubMember || {}, clubs || {});

    const clubAddress = (AddressBook || [])
      .find(({ AddressBookID }) => AddressBookID === ShippingAddressId) || {};

    const {
      Address1,
      Address2,
      City,
      StateShort,
      Zip,
      Zip4
    } = clubAddress || {};

    const diffTime = moment().diff(moment(MemberSince));
    const duration = moment.duration(diffTime);
    const years = duration.years();
    const months = duration.months();

    const {
      clubBillingAddress,
      LastFour,
      CardId
    } = getBillingAddressDetails(AddressBook, CreditCards);

    const { shoppingCartItems = [] } = cartResult || {};
    const hasClubMembershipInCart = acceptInvitationResult ||
      shoppingCartItems.some(({ clubContinuityTypeId }) => clubContinuityTypeId > 0)

    const {
      Address1: billingAddress1,
      Address2: billingAddress2,
      City: billingCity,
      StateShort: billingStateShort,
      Zip: billingZip,
      Zip4: billingZip4
    } = clubBillingAddress || {};

    return (
      <div id="content" className="site-content">
        <MetaLoader title="Club Information | Account | Twomey" />
        <MetaTags>
          <title>Club Information | Account | Twomey</title>
          <meta property="og:site_name" content="Twomey.com" />
          <meta
            property="og:title"
            content="Club Information | Account | Twomey"
          />
          <meta property="og:type" content="article" />
          <meta
            property="og:url"
            content="https://twomey.com/account/club-information"
          />
        </MetaTags>
        <div id="primary" className="content-area">
          <main id="main" className="site-main account-page nohero">
            <div className="container">
              <div className="row">
                <LeftNav />
                <div className="col-products club-info">

                  {inProgress && <Loading fullPage scrollToTop />}
                  {!inProgress &&
                    !IsActive &&
                    <div className="col-products club-info">
                      {!clubByIdInProgress &&
                        !validateLoginInProgress &&
                        !waitListStatusInProgress &&
                        <h1 className="smaller account-header">
                          Become a Twomey Member
                        </h1>}

                      <NonActiveMemberMessage
                        clubResult={clubResult}
                        user={user}
                        showModal={showModal}
                        joinWaitListResult={joinWaitListResult}
                        acceptInvitationResult={acceptInvitationResult}
                        waitlist={waitlist}
                        acceptInvitation={acceptInvitation}
                        validateLoginInProgress={validateLoginInProgress}
                        clubByIdInProgress={clubByIdInProgress}
                        waitListStatusInProgress={waitListStatusInProgress}
                      />
                    </div>}

                  {!inProgress &&
                    IsActive &&
                    <div >
                      {
                        !clubByIdInProgress &&
                        !switchInProgress &&
                        !validateLoginInProgress &&
                        !waitListStatusInProgress &&
                        !deleteInProgress &&
                        !switchError &&
                        !deleteError &&
                        <>
                          <h1 className="smaller account-header">
                            Membership Information
                          </h1>

                          <ActiveMemberMessage
                            clubResult={clubResult}
                            user={user}
                            showModal={showModal}
                            joinWaitListResult={joinWaitListResult}
                            acceptInvitationResult={acceptInvitationResult}
                            waitlist={waitlist}
                            acceptInvitation={acceptInvitation}
                            switchClubMembership={switchClubMembership}
                            clearGetClubById={clearGetClubById}
                            deleteWaitlist={deleteWaitlist}
                          />

                          <p className="account-info-block">
                            <strong>Membership Type</strong>
                            {memberClubName}
                          </p>
                          <p className="account-info-block">
                            <strong>Member Since</strong>
                            {MemberSince && moment(MemberSince).isValid()
                              ? moment(MemberSince).format('MMMM YYYY')
                              : ''}
                          </p>
                          <p className="account-info-block">
                            <strong>Duration</strong>
                            {years} Years, {months} Months
                          </p>
                          <Row>
                            <Col className="account-info-block">
                              {IsWillCallOnly ?
                                <strong>Your Current Pick up Location</strong>
                                :
                                <strong>Member Shipping Address</strong>

                              }
                              {IsWillCallOnly && WillCallLocation}<br />
                              {Address1}<br />
                              {Address2 && <span>{Address2}<br /></span>}
                              {City}
                              ,
                              {' '}
                              {StateShort}
                              {' '}
                              {Zip}
                              {Zip4 && `-${Zip4}`}
                              <br /><br />
                              <Link
                                to={
                                  `/account/edit-profile/address-book/${ShippingAddressId}`
                                }
                                className="edit"
                              >
                                Edit
                              </Link>
                            </Col>
                            <Col className="account-info-block">
                              <strong>Member Payment</strong>
                              <Row>
                                <Col>
                                  Card: ****-****-****-{LastFour}<br />
                                  {billingAddress1}<br />
                                  {billingAddress2 &&
                                    <span>{billingAddress2}<br /></span>}
                                  {billingCity}
                                  ,
                                  {' '}
                                  {billingStateShort}
                                  {' '}
                                  {billingZip}
                                  {billingZip4 && `-${billingZip4}`}
                                </Col>
                              </Row>

                              <Row>
                                <Link
                                  to={`/account/edit-profile/payment/${CardId}`}
                                  className="edit"
                                  style={{ marginRight: '150px', marginLeft: '15px' }}
                                >
                                  Edit
                                </Link>
                                <Link
                                  to={`/account/edit-profile/add-payment`}
                                  className="edit"
                                >
                                  Add
                                </Link>
                              </Row>
                            </Col>
                          </Row>
                          <div
                            className="account-info-block"
                            dangerouslySetInnerHTML={{
                              __html: clubHtml || ''
                            }}
                          />
                          <p className="account-info-block">
                            <Link to='#' onClick={() => { showModal('ClubCancellationModal') }}> Cancel Membership.</Link>
                          </p>
                        </>
                      }
                    </div>
                  }
                </div>
              </div>

              <VerifyAddressModal
                onHide={() => closeModal('VerifyAddressModal')}
                lookups={lookups}
                closeModal={closeModal}
                waitlist={waitlist}

              />
              <ClubPaymentModal
                user={user}
                lookups={lookups}
                waitListId={WaitlistId}
                clubTypeId={waitlist}
              />
              <ClubCancellationModal
                user={user}
                lookups={lookups}
                waitListId={WaitlistId}
                clubTypeId={waitlist}
                clubDisableTypes={clubDisableTypes}
              />
            </div>
          </main>

        </div>
        <div className="container text-right">
          <a href="#top" className="back-to-top" onClick={scrollToTop}>
            Back to top
          </a>
        </div>
      </div>
    );
  }
}

const mapState = state => {
  const {
    result: user,
    inProgress
  } = state.postLogin.toJS();

  const {
    error,
    inProgress: validateLoginInProgress
  } = state.validateLogin.toJS();

  const {
    result: clubResult,
    inProgress: clubByIdInProgress,
    error: getClubError
  } = state.getClubById.toJS();

  const {
    result: clubDisableTypes,
    inProgress: clubDisableTypesInProgress,
    error: clubDisableTypesError
  } = state.getClubDisableTypes.toJS();

  const {
    inProgress: waitListStatusInProgress,
    result: userWaitListStatusResult,
    error: waitListStatusError
  } = state.getUserWaitListStatus.toJS();

  const {
    result: lookups
  } = state.getLookups.toJS();

  const {
    result: joinWaitListResult
  } = state.joinWaitList.toJS();

  const {
    result: acceptInvitationResult,
    inProgress: acceptInvitationInProgress,
    error: acceptInvitationError
  } = state.acceptInvitation.toJS();

  const {
    result: cartResult,
    inProgress: getCartInProgress
  } = state.getCart.toJS();

  const {
    error: switchError,
    inProgress: switchInProgress
  } = state.switchClubMembership.toJS();

  const {
    error: deleteError,
    inProgress: deleteInProgress
  } = state.deleteWaitlist.toJS();


  const { clubs } = state.wordpress || {};

  return {
    user,
    clubs,
    inProgress,
    error,
    clubResult,
    clubByIdInProgress,
    clubError: getClubError || waitListStatusError || acceptInvitationError,
    lookups,
    joinWaitListResult,
    waitListStatusInProgress,
    userWaitListStatusResult,
    acceptInvitationResult,
    cartResult,
    getCartInProgress,
    acceptInvitationInProgress,
    switchError,
    switchInProgress,
    validateLoginInProgress,
    deleteError,
    deleteInProgress,
    clubDisableTypes,
    clubDisableTypesInProgress,
    clubDisableTypesError
  };
};

const mapDispatch = dispatch => (
  bindActionCreators({
    getClubById: fetchDux.getClubById.createAction,
    clearGetClubById: fetchDux.getClubById.clearAction,
    getLookups: fetchDux.getLookups.createAction,
    joinWaitList: fetchDux.joinWaitList.createAction,
    getUserWaitListStatus: fetchDux.getUserWaitListStatus.createAction,
    acceptInvitation: fetchDux.acceptInvitation.createAction,
    switchClubMembership: fetchDux.switchClubMembership.createAction,
    getClubDisableTypes: fetchDux.getClubDisableTypes.createAction,
    validateLogin: fetchDux.validateLogin.createAction,
    deleteWaitlist: fetchDux.deleteWaitlist.createAction,
    ...actionCreators
  }, dispatch)
)

export default connect(mapState, mapDispatch)(ClubInformation);
